import React from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress, configure_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as DownloadsIcon } from "../../../assets/svg/downloads.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const Downloads = () => {
    const dispatch = useDispatch();
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                explore_downloads: 1,
            },
        };
        localStorage.setItem("activeModule", "Listening");
        dispatch(setActiveModule("Listening"));
        dispatch(configure_getting_started_progress(obj));
    };

    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <DownloadsIcon className="icon_content fill_svg" />
                        <span className="content_title">Downloads</span>
                    </div>
                    <div className="text_content">
                        <p>{`
                        You can download data from the conversations page.  Once a download is initiated, it sets up a download job in the queue and you can visit the downloads section to view the status of this job and download the file when ready.`}</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/downloads">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/E7JPFkYTfeA"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default Downloads;
